import {FINISH_LOADING_APPLICATION, RETRIEVE_DOMAIN_DETAILS, RLTD_ACC_NOT_AVL} from "../action";
import { getDomainDetails } from "../api/api.js";

export function fetchDomainDetails() {
  return (dispatch) => {
    return getDomainDetails().then((data) => {
      try {
        if (data) {
          dispatch({type: RETRIEVE_DOMAIN_DETAILS, payload: data});
        } else {
          dispatch({type: RLTD_ACC_NOT_AVL});
          dispatch({ type: FINISH_LOADING_APPLICATION });
        }
      }catch(error){
        dispatch({ type: RLTD_ACC_NOT_AVL });
        dispatch({ type: FINISH_LOADING_APPLICATION });
      } finally {
        dispatch({ type: FINISH_LOADING_APPLICATION });
      }
    });
  };
}
